import React from 'react';

import { DropdownInput, Checkbox, informationIcon, } from '../../../../Shared';
import DemoGuardedButton from '../../shared/demoGuardedButton';

const TeacherEmailNotifications = ({ activateSection, active, deactivateSection, resetTeacherNotificationSection, setTeacherNotificationOption, notificationEmailFrequency, notificationSettings, sendNewsletter, updateUser, updateNotificationSettings, updateTeacherInfo }) => {

  React.useEffect(() => {
    if (active) { return }

    resetTeacherNotificationSection()
  }, [active])

  React.useEffect(() => {
    if (!Object.values(notificationSettings).some(v => v === true)) { return }
    if (notificationEmailFrequency !== 'never') { return }

    updateNotificationEmailFrequency({value: 'daily'})
  }, [notificationSettings])

  React.useEffect(() => {
    if (notificationEmailFrequency !== 'never') { return }

    unsetAllNotificationSettings()
  }, [notificationEmailFrequency])

  function resetAndDeactivateSection() {
    resetTeacherNotificationSection()
    deactivateSection()
  }

  function toggleSendNewsletter() {
    setTeacherNotificationOption("postSendNewsletter", !sendNewsletter)
  };

  function toggleNotificationSetting(setting) {
    setTeacherNotificationOption("tempTeacherNotificationSettings",
      {
        ...notificationSettings,
        ...{ [setting]: !notificationSettings[setting] }
      }
    )
  }

  function updateNotificationEmailFrequency(e) {
    activateSection()
    setTeacherNotificationOption("postNotificationEmailFrequency", e.value)
  }

  function unsetAllNotificationSettings() {
    Object.keys(notificationSettings).forEach(k => notificationSettings[k] = false)

    setTeacherNotificationOption("tempTeacherNotificationSettings", notificationSettings)
  }

  function handleSubmit(e) {
    e?.preventDefault()

    updateUser({
      send_newsletter: sendNewsletter,
      school_options_do_not_apply: true,
    }, '/teachers/update_my_account', 'Settings saved')

    updateNotificationSettings({
      notification_types: notificationSettings
    })

    updateTeacherInfo({
      notification_email_frequency: notificationEmailFrequency
    })
  }

  function renderStudentEventCheckboxes() {
    const notificationSettingsToLabels = {
      "TeacherNotifications::StudentCompletedDiagnostic": "Student completed diagnostic",
      "TeacherNotifications::StudentCompletedAllDiagnosticRecommendations": "Student completed all diagnostic recommendations",
      "TeacherNotifications::StudentCompletedAllAssignedActivities": "Student completed all assigned activities"
    }

    return Object.entries(notificationSettings).map((entry) => {
      const [setting, value] = entry

      const label = notificationSettingsToLabels[setting]

      return(
        <Checkbox
          key={label}
          label={label}
          onClick={() => toggleNotificationSetting(setting)}
          selected={value}
        />
      )
    })
  }

  function renderNotificationEmailFrequencyDropdown() {
    const options = [
      { value: 'never', label: 'Never' },
      { value: 'hourly', label: 'Hourly' },
      { value: 'daily', label: 'Daily' },
      { value: 'weekly', label: 'Weekly' }
    ]

    const selectedOption = options.find((option) => option.value === notificationEmailFrequency)

    return (
      <div className="notification-frequency-dropdown-container">
        <DropdownInput
          className="small bordered"
          handleChange={updateNotificationEmailFrequency}
          id="frequency-dropdown"
          label="Frequency"
          options={options}
          value={selectedOption}
        />
        <p className="email-notice">
          You will only receive a notification email if an event occurs.
        </p>
      </div>
    )
  }

  function renderButtonSection() {
    if (!active) { return }

    return (
      <div className="button-section">
        <button className="quill-button outlined medium grey focus-on-light" id="cancel" onClick={resetAndDeactivateSection} type="button">Cancel</button>
        <DemoGuardedButton className="quill-button contained medium green focus-on-light" onClick={handleSubmit}>Save changes</DemoGuardedButton>
      </div>
    )
  }

  return (
    <section aria-labelledby="emailPreferencesTitle" className="teacher-account-email-notifications user-account-section">
      <h1 id="emailPreferencesTitle">Email Preferences</h1>
      <form acceptCharset="UTF-8" onSubmit={handleSubmit}>
        <div className="fields" onClick={activateSection}>
          <h2>Newsletters</h2>
          <div className="checkboxes">
            <Checkbox
              label="Bi-weekly newsletter"
              onClick={toggleSendNewsletter}
              selected={sendNewsletter}
            />
          </div>
          <h2>Notifications</h2>
          <div className="checkboxes student-events">
            {renderStudentEventCheckboxes()}
          </div>
          <h2 className="frequency-label">Notification frequency</h2>
          {renderNotificationEmailFrequencyDropdown()}
        </div>
      </form>
      {renderButtonSection()}
    </section>
  )
}

export default TeacherEmailNotifications
